import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { Initiative } from '../../../../api/initiative-client/initiative-client.type';
import type { Goal, Outcome } from '../../../../api/strategy-client/strategy-client.type';
import { getCurrency } from '../../../../helpers/currency-helpers';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { SideSectionInfoItem } from './side-section-info-item';
import { getEntityInfo } from './side-section.helpers';

type EntityType = 'initiative' | 'outcome' | 'goal';

type Props = {
  entity: Initiative | Outcome | Goal;
  entityType: EntityType;
};

export const SideSectionInfo = ({ entity, entityType }: Props) => {
  const { t } = useTranslation();
  const teams = useGlobalStore((state) => state.teams);
  const organization = useGlobalStore((state) => state.organization);
  const { code: currencyCode } = getCurrency(organization);

  return (
    <Stack gap={8}>
      {getEntityInfo(entity, entityType, teams, t, currencyCode).map(({ label, value }) => (
        <SideSectionInfoItem key={label} label={label} value={value} />
      ))}
    </Stack>
  );
};
